import _slicedToArray from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var UNDEF;
export default (function (a) {
  var b = {
    maxOnly: function maxOnly(a, b, c) {
      var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var e = arguments.length > 4 ? arguments[4] : undefined;
      var f,
          g = c[b].value,
          h = b;

      for (var j = b - 1; j >= a; --j) {
        f = d[j] === UNDEF ? c[j].value : d[j], f > g && (g = f, h = j);
      }

      return e.push(h), e;
    },
    minMax: function minMax(a, b, c) {
      var _ref, _ref2;

      var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var e = arguments.length > 4 ? arguments[4] : undefined;
      var f,
          g = c[b].value,
          h = b,
          j = c[b].value,
          k = b;

      for (var l = b - 1; l >= a; --l) {
        f = d[l] === UNDEF ? c[l].value : d[l], f > g ? (g = f, h = l) : f < j && (j = f, k = l);
      }

      return (_ref = k < h ? [k, h] : [h, k], _ref2 = _slicedToArray(_ref, 2), k = _ref2[0], h = _ref2[1], _ref), e.push(k), k !== h && e.push(h), e;
    }
  };
  return b[a] || b.maxOnly;
});